import React from "react";

const Timeline = ({ steps }) => {

  return (
    <div className="timeline-container">
      {steps.map((step, index) => (
        <div key={step.id} className="timeline-step">
          <div
            className={`step-circle ${
              step.status === "approved"
                ? "completed"
                : step.status === "rejected"
                  ? "rejected"
                  : "pending"
            }`}
          >
            {index + 1}
          </div>
          <div className="step-details">
            <strong>{step.name}</strong>
            <p>{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
